import { Component, computed, inject } from '@angular/core';
import { AssetCard } from '../../shared/asset-card/asset-card';
import { AssetService } from '../../services/asset-service/asset.service';
import { AssetListRequestQueryParams } from '../../services/asset-service/types';
import { Loader } from '../../shared/loader';

@Component({
  selector: 'recent-bookmarks',
  templateUrl: './recent-bookmarks.html',
  styleUrl: './recent-bookmarks.scss',
  imports: [AssetCard, Loader],
})
export class RecentBookmarks {
  assetService = inject(AssetService);

  readonly recentBookmarkIds = this.assetService.getDiscoverPageRecentBookmarks;

  readonly assetListParams = computed(() => {
    let assetIds: string[] = [];
    if (this.recentBookmarkIds.hasValue()) {
      assetIds = this.recentBookmarkIds.value().items.map(({ asset_id }) => asset_id);
    }

    const params: AssetListRequestQueryParams = {
      asset_ids: assetIds,
    };

    return params;
  });

  readonly bookmarkedAssetList = this.assetService.getOnlySpecifiedAssetListById(
    this.assetListParams,
  );
}
